module.exports = __webpack_public_path__ + "static/img/pic_zhengjian@2x.de88c0ee.png";